export default (gettext, env, obj, string) => {
  const marketplaceStrings = {
    salita: {
      domainData: {
        platformName: 'Salita',
        platformFullName: gettext('Salita AS'),
        platformOrgNumber: '918 586 296',
        supportEmail: 'post@salita.no',
        subSupportEmail: 'post@salita.no',
        supportFinanceEmail: 'regnskap@salita.no',
        supportFinancePersonEmail: 'regnskap@salita.no',
        supportInterpreterEmail: 'regnskap@salita.no',
        hrEmail: 'hr@salita.no',
        interpreterSupportPhone: '22120119',
        supportPhone: '04523',
        supportPhoneText: '04523',
        supportTranslationPhone: '+4723961032',
        supportTranslationEmail: 'oversettelse@salita.no',
        infoPortalLink: 'https://www.salita.no/',
        infoPortalText: 'salita.no',
        supportPortalLink: 'https://support.salita.no/',
        supportPortalText: 'support.salita.no',
        platformLink: 'https://my.salita.no',
        platformText: 'my.salita.no',
        termLink: 'https://salita.no/terms',
        privacyLink: 'https://salita.no/privacy',
        financeGuideLink: 'https://support.salita.no/article/368-retningslinjer-for-fakturering/',
        ssoRedirectLink: 'http://localhost:3001/v1/accounts/oauth/boxyhqsaml?tenant=827&product=tt-core',
      },
      metaData: {
        faviconPath: '/static/favicons_salita',
        adminFaviconPath: '/static/favicons_salita/admin',
        shortTitle: gettext('Salita'),
        longTitle: gettext('Salita - The new standard in interpretation'),
        adminTitle: gettext('Salita Admin'),
        description: gettext('Salita is an open and transparent marketplace for interpretation services. We connect interpreters with customers worldwide. Register for free today!')
      },
      rootPath: {
        development: 'localhost:4000',
        testing: 'qa.my.salita.no',
        backend: 'rc.my.salita.no',
        staging: 'rc.my.salita.no',
        production: 'my.salita.no'
      },
      social: {
        facebookLink: 'https://www.facebook.com/salitatt',
        twitterLink: 'https://twitter.com/SalitaTT',
        linkedinLink: 'https://www.linkedin.com/company/salita-interpreting-and-translation-services/about/',
        hashtag: gettext('Salita'),
        shareMessage: gettext('Take a look at Salita, an open marketplace for interpretation services. Anyone can join and help!')
      },
      app: {
        androidAppLink: process.env.ANDROID_APP_LINK,
        iosAppLink: process.env.IOS_APP_LINK,
      },
      footer: {
        copyright: gettext('© Salita AS'),
        address: gettext('Pilestredet 17, Oslo - 0164, Norway'),
        certificate: '',
      }
    },
    tolkenett: {
      domainData: {
        platformName: 'Tolkenett',
        platformFullName: gettext('Tolkenett AS'),
        platformOrgNumber: '935 975 131',
        supportEmail: 'post@tolkenett.no',
        subSupportEmail: 'post@tolkenett.no',
        supportFinanceEmail: 'post@tolkenett.no',
        supportFinancePersonEmail: 'post@tolkenett.no',
        supportInterpreterEmail: 'post@tolkenett.no',
        hrEmail: 'post@tolkenett.no',
        interpreterSupportPhone: '22993299',
        supportPhone: '22993299',
        supportPhoneText: '22 99 32 99',
        supportTranslationPhone: '+4722993299',
        supportTranslationEmail: 'oversettelse@tolkenett.no',
        infoPortalLink: 'https://tolkenett.no/',
        infoPortalText: 'tolkenett.no',
        supportPortalLink: 'https://tolkenett.no/kontakt',
        supportPortalText: 'tolkenett.no/kontakt',
        platformLink: 'https://my.tolkenett.no',
        platformText: 'my.tolkenett.no',
        // Tolkenett publishes no terms page; an empty link is dropped rather
        // than pointing Tolkenett customers at Salita's terms.
        termLink: '',
        privacyLink: 'https://tolkenett.no/legal/personvern',
        financeGuideLink: 'https://support.salita.no/article/368-retningslinjer-for-fakturering/',
        ssoRedirectLink: 'http://localhost:3001/v1/accounts/oauth/boxyhqsaml?tenant=827&product=tt-core',
      },
      metaData: {
        faviconPath: '/static/favicons_tolkenett',
        adminFaviconPath: '/static/favicons_tolkenett',
        shortTitle: gettext('Tolkenett'),
        longTitle: gettext('Tolkenett - Translation services'),
        adminTitle: gettext('Tolkenett Admin'),
        description: gettext('Tolkenett is a marketplace for translation services. Order translations of documents and files from qualified translators.')
      },
      rootPath: {
        development: 'localhost:4000',
        testing: 'qa.my.salita.no',
        backend: 'rc.my.salita.no',
        staging: 'rc.my.salita.no',
        production: 'my.tolkenett.no'
      },
      social: {
        facebookLink: 'https://www.facebook.com/people/Tolkenett/61557984071097/',
        twitterLink: '#',
        linkedinLink: 'https://www.linkedin.com/company/tolkenett-as/',
        hashtag: gettext('Tolkenett'),
        shareMessage: gettext('Take a look at Tolkenett, a marketplace for translation services.')
      },
      app: {
        androidAppLink: process.env.ANDROID_APP_LINK,
        iosAppLink: process.env.IOS_APP_LINK,
      },
      footer: {
        copyright: gettext('© Tolkenett AS'),
        address: gettext('Schweigaards gate 12, 0185 Oslo, Norway'),
        certificate: '',
      }
    },
    court: {
      domainData: {
        platformName: 'Domstol',
        platformFullName: gettext('Norges Domstoler'),
        platformOrgNumber: '984 195 796',
        supportEmail: 'post@salita.no',
        subSupportEmail: 'post@salita.no',
        supportFinanceEmail: 'regnskap@salita.no',
        supportFinancePersonEmail: 'regnskap@salita.no',
        supportInterpreterEmail: 'regnskap@salita.no',
        hrEmail: 'hr@salita.no',
        interpreterSupportPhone: '0123',
        supportPhone: '0123',
        supportPhoneText: '0123',
        supportTranslationPhone: '+47123',
        supportTranslationEmail: 'oversettelse@salita.no',
        infoPortalLink: 'https://www.domstol.no/no/',
        infoPortalText: 'domstol.no',
        supportPortalLink: '#',
        supportPortalText: '#',
        platformLink: 'https://tolk.domstoltolk-sandbox.no',
        platformText: 'domstol.no',
        termLink: '#',
        privacyLink: '#',
        financeGuideLink: '#',
        ssoRedirectLink: 'http://localhost:3001/v1/accounts/oauth/boxyhqsaml?tenant=827&product=tt-core',
      },
      metaData: {
        faviconPath: '/static/favicons_domstol',
        adminFaviconPath: '/static/favicons_domstol',
        shortTitle: gettext('Norges Domstoler'),
        longTitle: gettext('Norges domstoler | Norges domstoler'),
        adminTitle: gettext('Norges Domstoler'),
        description: gettext('Norges Domstoler is an open and transparent marketplace for interpretation services. We connect interpreters with customers worldwide. Register for free today!')
      },
      rootPath: {
        development: 'localhost:4000',
        testing: 'tolk.domstoltolk-sandbox.no',
        backend: 'tolk.domstoltolk-sandbox.no',
        staging: 'tolk.domstoltolk-sandbox.no',
        production: 'tolk.domstoltolk-sandbox.no'
      },
      social: {
        facebookLink: '#',
        twitterLink: '#',
        linkedinLink: '#',
        hashtag: gettext('Norges Domstoler'),
        shareMessage: gettext('Take a look at Norges Domstoler, an open marketplace for interpretation services. Anyone can join and help!')
      },
      app: {
        androidAppLink: process.env.ANDROID_APP_LINK,
        iosAppLink: process.env.IOS_APP_LINK,
      },
      footer: {
        copyright: gettext('© Norges Domstoler'),
        address: gettext('Dronningens gate 2, 7011 Trondheim, Norway'),
        certificate: '',
      }
    }
  };
  return marketplaceStrings[env][obj][string] || '';
};
